import type { RootState } from '../reducers/rootReducer.ts';
import type { IError, IInfo, IWarning } from '../models/snackbar/snackbar.ts';

export const errors = (state: RootState): IError[] => state.snackBarElements.errors;
export const info = (state: RootState): IInfo[] => state.snackBarElements.info;
export const warnings = (state: RootState): IWarning[] => state.snackBarElements.warnings;
